<template>
	<div class="col-12">
		<div class="row">
			<b-overlay :show="loading" class="content">
				<div class="w-100 mb-3 float-left">
					<button type="button"
							class="btn btn-light text-right"
							@click="showFilters = true">
						<font-awesome-icon class="mr-2 ml-2" icon="sliders-h" /> تنظیمات صفحه
					</button>
				</div>
				<table v-if="screenWidth > 1021"
					   class="table table-bordered bg-white table-striped text-center">
					<thead>
						<tr>
							<th v-for="field in fields" v-if="field.showCell" :key="field.key">
								{{ $t("param." + field.key) }}
							</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item, index) in items">
							<td v-for="field in fields" v-if="field.showCell">
								<span v-if="field.key == 'record'">
									{{ index + (currentPage - 1) * perPage + 1 }}
								</span>
								<span v-else-if="field.key == 'actions'">
									<button class="btn btn-outline-dark btn-sm m-1"
											@click="onShowDatails(item)">
										مشاهده جزئیات کامل درخواست
									</button>
								</span>
								<span v-else v-bind:class="{ 'card-number': field.cardNumber }">
									{{ item[field.key] }}
								</span>
							</td>
						</tr>
					</tbody>
				</table>
				<table v-if="screenWidth < 1024"
					   v-for="(item, index) in items"
					   class="table table-light table-sm table-silver table-mobile mb-2 text-right">
					<tr v-for="field in fields" v-if="field.showCellMobile">
						<th>
							{{ $t("param." + field.key) }}
						</th>
						<td>
							<span v-if="field.key == 'record'">
								{{ index + (currentPage - 1) * perPage + 1 }}
							</span>
							<span v-else-if="field.key == 'actions'">
								<button class="btn btn-outline-dark btn-sm m-1"
										@click="onShowDatails(item)">
									مشاهده جزئیات کامل درخواست
								</button>
							</span>
							<span v-else v-bind:class="{ 'card-number': field.cardNumber }">
								{{ item[field.key] }}
							</span>
						</td>
					</tr>
				</table>

				<b-pagination dir="ltr"
							  pills
							  @input="initTable"
							  v-model="currentPage"
							  :total-rows="totalFilteredRows"
							  :per-page="perPage"
							  size="sm"></b-pagination>
			</b-overlay>
		</div>
		<b-modal size="lg" hide-footer v-model="showFilters">
			<div class="col-12">
				<div class="row">
					<div class="col-12 col-md-7 float-right">
						<table class="table table-borderless text-right">
							<tr>
								<td>{{ $t("param.table.perPage") }}</td>
								<td>
									<b-form-select :options="perPageOptions" class="form-control" v-model="perPageSelectedOption"></b-form-select>
								</td>
							</tr>
							<tr>
								<td>{{ $t("param.table.fromDate") }}</td>
								<td>
									<date-picker color="#f5c842" v-model="fromDate" :clearable="true" />
								</td>
							</tr>
							<tr>
								<td>{{ $t("param.table.toDate") }}</td>
								<td>
									<date-picker color="#f5c842" v-model="toDate" :clearable="true" />
								</td>
							</tr>
						</table>
					</div>
					<div class="col-12 col-md-5 float-right">
						<table class="table text-right table-light">
							<tr v-for="(field, index) in fields" v-if="field.shotDetails">
								<th>{{ $t("param." + field.key) }}</th>
								<td>
									<b-form-checkbox switch v-model="fields[index].showCell" size="lg"></b-form-checkbox>
								</td>
							</tr>
						</table>
					</div>
					<button class="btn btn-outline-dark" @click="initFilters">
						اعمال تنظیمات
					</button>
				</div>
			</div>
		</b-modal>
		<b-modal size="xl" hide-footer v-model="showDetails">
			<CustomerRequestDetails :requestId="selected.requestId" />
		</b-modal>
	</div>
</template>
<script>
	import CustomerRequestDetails from "@/views/club/CustomerRequestDetails";

	export default {

		components: {
			CustomerRequestDetails
		},

		data()
		{
			return {
				screenWidth: null,
				loading: false,
				showDetails: false,
				showFilters: false,
				creditRejectRequest: null,
				showCreditRejectRequestModal: false,
				creditRejectRequestIsLoading: false,
				selected: {},
				items: [],
				fields: [
					{
						key: "record",
						showCell: true,
						shotDetails: false
					},
					{
						key: "requestTypeName",
						showCell: true,
						showCellMobile: true,
						shotDetails: true,
						cardNumber: true
					},
					{
						key: "requestId",
						showCell: true,
						shotDetails: false
					},
					{
						key: "orderNumber",
						showCell: false,
						shotDetails: false
					},
					{
						key: "requestTypeStatus",
						showCell: true,
						showCellMobile: true,
						shotDetails: true
					}
					,
					{
						key: "persianCreateDate",
						showCell: true,
						showCellMobile: true,
						shotDetails: true
					},
					{
						key: "createTime",
						showCell: true,
						showCellMobile: true,
						shotDetails: true
					},
					{
						key: "actions",
						showCell: true,
						showCellMobile: true,
						shotDetails: false
					}
				],
				fromDate: null,
				toDate: null,
				totalRows: 1,
				totalFilteredRows: 1,
				currentPage: 1,
				perPage: 10,
				perPageSelectedOption: "10",
				perPageOptions: [
					{ text: 10, value: 10 },
					{ text: 50, value: 50 },
					{ text: 100, value: 100 },
					{ text: 500, value: 500 }
				]
			};
		},

		beforeMount()
		{
			this.screenWidth = window.outerWidth;
			this.initTable();
		},

		mounted()
		{
			this.totalRows = this.items.length;
		},

		methods: {
			initFilters()
			{
				this.showFilters = false;
				this.perPage = Number(this.perPageSelectedOption);
				this.initTable();
			},

			initTable()
			{
				this.loading = true;

				const data = {
					Search: "",
					Start: (this.currentPage - 1) * this.perPage,
					Length: this.perPage,
					FromDate: this.fromDate,
					ToDate: this.toDate
				};

				axios({ method: "post", url: "/api/App/GetCustomerRequests", data: data })
					.then(response =>
					{
						var validItems = [];
						var items = response.data.meta.requests;
						var creditRejectLength = 0;

						for (var i = 0; i < items.length; i++)
						{
							if (items[i].requestTypeId == 65 && items[i].requestTypeStatusId == 1)
							{
								creditRejectLength += 1;
								this.creditRejectRequest = items[i];
							}
							else
							{
								validItems.push(items[i]);
							}
						}

						this.items = validItems;
						this.totalRows = response.data.meta.totalRows - creditRejectLength;
						this.totalFilteredRows = response.data.meta.totalFilteredRows;
						this.loading = false;

					})
					.catch(error => { });
			},

			sendFollowRequest()
			{

			},


			sendRequest()
			{
				this.creditRejectRequestIsLoading = true;

				axios({ method: "post", url: "/api/App/SaveRequest", data: { RequestTypeID: this.selectedRequest.requestTypeId, NewPassword: this.newPassword } })
					.then(response =>
					{
						this.creditRejectRequestIsLoading = false;
						if (response.data.success)
						{
							this.$bvToast.toast('درخواست شما با موفقیت ثبت شد', {
								title: 'عملیات موفق',
								toaster: 'b-toaster-top-center',
								variant: 'success',
								bodyClass: 'text-center',
								noCloseButton: true,
								solid: true
							})

							return;
						}

						this.$bvToast.toast('خطا در ثبت درخواست، لطفا با پشتیانی سیستم تماس بگیرید.', {
							title: 'عملیات ناموفق',
							toaster: 'b-toaster-top-center',
							variant: 'danger',
							bodyClass: 'text-center',
							noCloseButton: true,
							solid: true
						})
					})
					.catch(error =>
					{
						this.creditRejectRequestIsLoading = false;
						this.$bvToast.toast('خطا در ثبت درخواست، لطفا با پشتیانی سیستم تماس بگیرید.', {
							title: 'عملیات ناموفق',
							toaster: 'b-toaster-top-center',
							variant: 'danger',
							bodyClass: 'text-center',
							noCloseButton: true,
							solid: true
						})
					});
			},



			onShowDatails(item)
			{
				this.selected = item;
				this.showDetails = true;
			}
		}
	};
</script>
<style>
	.card-number {
		display: inline-block;
		direction: ltr;
	}
</style>
